import React from 'react'
import { useTranslation } from 'react-i18next'

interface MessageStatusProps {
  onClick?: () => void
}

export default function MessageStatus(props: MessageStatusProps) {
  const { t } = useTranslation()

  return (
    <div className="alert alert-warning" role="alert">
      <pre className="mb-0" style={{fontFamily: 'inherit'}}>
        {t("login.messageStatus.optOut")} <button type="button" className="btn btn-link alert-link p-0" onClick={props.onClick}>{t("login.messageStatus.switchToVoiceCall")}</button>
      </pre>
    </div>
  )
}
